import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { primary, neutral, white } from '../../../../style/colors';
import { MOBILE_BREAKPOINT, flexCenter, baseButton, popIn } from '../Header.style';

export const Nav = styled.nav`
  ${flexCenter}
  gap: 0;
  flex: 1;
  justify-content: center;
  max-width: 700px;

  @media (max-width: ${MOBILE_BREAKPOINT}) { display: none; }
`;

export const NavTab = styled.button`
  ${baseButton}
  ${flexCenter}
  position: relative;
  color: ${({ $active }) => ($active ? neutral[900] : neutral[500])};
  padding: 10px 24px;
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? '600' : '500')};
  white-space: nowrap;
  gap: 8px;

  &:hover {
    color: ${neutral[900]};
    background: ${neutral[50]};
  }

  &:active { transform: scale(0.98); }

  ${({ $active }) => $active && css`
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: ${primary[500]};
      border-radius: 3px 3px 0 0;
    }
  `}

  i { font-size: 18px; }
`;

export const Badge = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  background: ${primary[500]};
  color: ${white};
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
  box-shadow: 0 2px 8px ${rgba(primary[500], 0.4)};
  animation: ${popIn} 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;
